import { render, staticRenderFns } from "./FAQLOGIN.vue?vue&type=template&id=c79268fe&scoped=true&"
import script from "./FAQLOGIN.vue?vue&type=script&lang=js&"
export * from "./FAQLOGIN.vue?vue&type=script&lang=js&"
import style0 from "./FAQLOGIN.vue?vue&type=style&index=0&id=c79268fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79268fe",
  null
  
)

export default component.exports